import React, { useRef } from "react";

const SearchFacets = props => {
  const elRef = useRef(null);
  const facets = JSON.parse(props.facets);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const handleChange = () => {
    const facets = elRef.current.querySelectorAll(".categoryFacet");

    let values = [];

    facets.forEach(facet => {
      values.push(facet.value);
    });

    values = values.filter(Boolean); // remove empty values

    const fullTextQuery = document.querySelector("#search-banner-field").value || "%20";

    // manually set full URL to remove pagination pathing
    window.location = `${window.location.protocol}//${
      window.location.host
    }/search/${fullTextQuery}?cat=${values.join("+")}`;
  };

  const defaultValue = facet => {
    const categories = urlParams.get("cat");

    if (categories) {
      const possibleValues = facet.children.map(term => term.term_id);

      const currentValues = categories
        .split(" ") // though we are using "+" symbols to separate category ids, these actually get interpretted as spaces
        .map(category => parseInt(category));

      const value = currentValues.filter(value =>
        possibleValues.includes(value)
      );

      return value[0];
    }
  };

  return (
    <form className="u-form u-mt4" ref={elRef}>
      {facets.map((facet, i) => (
        <div className="u-mb2" key={i}>
          <label htmlFor={`facet-${i}`}>{facet.name}</label>
          <select
            onChange={handleChange}
            className="categoryFacet"
            name="cat"
            id={`facet-${i}`}
            defaultValue={defaultValue(facet)}
          >
            <option value="">Select one</option>
            {facet.children.map((term, i) => (
              <option key={i} value={term.term_id}>
                {term.name}
              </option>
            ))}
          </select>
        </div>
      ))}
    </form>
  );
};

export default SearchFacets;
